<template>
  <div class="learning_certificate">
    <!-- <div class="certificate_top mar_top_20 mar_bottom_20">
      你获得了
      <span class="text_active">{{ certificateList.length }}</span> 张证书
    </div>
    <div class="certificate_list" ref="content" :class="{ expanded: isExpanded }">
      <div
        class="certificate_one flex Flexalign mar_bottom_20"
        v-for="(item, index) in certificateList"
        :key="index"
      >
        <div class="left_img">
          <el-image
            class="certificate_img"
            :src="iconPath('certificate_img.png')"
          ></el-image>
        </div>
        <div class="right_content mar_left_20 flex FlexBetween flexcolumn flex-1">
          <div class="certificate_name">{{ item.name }}</div>
          <div class="certificate_score">
            获得分数：<span class="text_active">{{ item.score }}</span> 分
          </div>
          <div class="flex Flexalign FlexBetween certificate_score">
            <div>{{ item.time }}</div>
            <div class="flex flexcolumn Flexalign">
              <div>
                <el-image
                  class="download_icon"
                  :src="iconPath('download_icon.png')"
                ></el-image>
              </div>
              <div class="download_text">下载</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more_load flex Flexalign Flexjustify cursor_pointer" v-if="showLoadMore" @click="toggleExpand">
      {{ isExpanded ? '收起' : '查看更多记录' }}
      <el-icon v-if="!isExpanded">
        <ArrowDown />
      </el-icon>
      <el-icon v-else>
        <ArrowUp />
      </el-icon>
    </div> -->
    <moe-empty url="development_icon_gray.png" emptyText="功能开发中，敬请期待"></moe-empty>
  </div>
</template>

<script>
export default {
  name: "GjkcH5LearningCertificate",

  data() {
    return {
      certificateList: [
        {
          certificateImg: "",
          name: "高中函数初步解析",
          score: 90,
          time: "2024-12-20",
          link: "",
        },
        {
          certificateImg: "",
          name: "高中函数初步解析",
          score: 90,
          time: "2024-12-20",
          link: "",
        },
        {
          certificateImg: "",
          name: "高中函数初步解析",
          score: 90,
          time: "2024-12-20",
          link: "",
        },
        {
          certificateImg: "",
          name: "高中函数初步解析",
          score: 90,
          time: "2024-12-20",
          link: "",
        },
        {
          certificateImg: "",
          name: "高中函数初步解析",
          score: 90,
          time: "2024-12-20",
          link: "",
        },
      ],
      isExpanded: false,
      showLoadMore: false,
    };
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.$nextTick(this.checkOverflow);
      },
    },
  },

  mounted() {
    this.checkOverflow();
  },

  methods: {
    checkOverflow() {
      if (!this.$refs.content) return
      this.showLoadMore = this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.learning_certificate {
  .certificate_top {
    font-size: 18px;
    color: #111111;
  }
  .certificate_list {
    position: relative;
    max-height: 650px;
    overflow: hidden;
    .certificate_one {
      width: 810px;
      height: 152px;
      background: #f5f6f8;
      border-radius: 10px;
      padding: 20px;
      box-sizing: border-box;
      .left_img {
        .certificate_img {
          width: 200px;
          height: 112px;
        }
      }
      .right_content {
        height: 112px;
        .certificate_name {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }
        .certificate_score {
          color: #666666;
        }
        .certificate_score {
          color: #999999;
          .download_icon {
            width: 24px;
            height: 20px;
          }
          .download_text {
            font-size: 14px;
          }
        }
      }
    }
  }
  .certificate_list.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 200px;
    height: 35px;
    background: #F5F6F8;
    border-radius: 8px;
    line-height: 35px;
    text-align: center;
    margin: 10px auto;
  }
}
</style>